import {
  Dropdown,
  Form,
  Space,
  Button,
  Flex,
  Tooltip,
  Tag
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
  useImperativeHandle
} from "react";
import {
  MenuOutlined,
  HistoryOutlined,
  FormOutlined,
  PlusOutlined,
  SearchOutlined
} from "@ant-design/icons";
import http from "@/utils/http";
import moment from "moment";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import VendorMWorkerModal from "./compontent/VendorMWorkerModal" ;
import ChangeAmountModal from "./compontent/ChangeAmountModal" ;
import VendorTypeModal from "./compontent/VendorTypeModal";
import EditHistory from "@/views/AccountPayable/VendorMWorker/EditHistory";
import { CustomTable, CustomTableExtend } from "@/hocComponents";

const VendorMWorker = forwardRef((props, ref) => {
  const [propTypeList, setPropTypeList] = useState([]);
  const [supervisorList, setSupervisorList] = useState([]);
  const vendorMWorkerModalRef = useRef(null);
  const changeAmountModalRef = useRef(null);
  const vendorTypeModalRef = useRef(null);
  const editHistoryModalRef = useRef(null);

  const initTableHead = {
    vendorId: undefined,
    name: undefined,
    monthlySalary: undefined,
    appActive: undefined,
    phone: undefined,
    fedId: undefined,
    groupCode: undefined,
    propName: undefined,
    supervisors: undefined,
    status: undefined,
    lastIssueCheck: undefined,
  }

  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const initColumns = [
    // {
    //   title: '#',
    //   dataIndex: '#',
    // },
    {
      title: 'Action',
      dataIndex: "viewDetail",
      titleType: "",
      width: 60, 
      render: (text, record) => (
        (commonFn.btnAuthorityFlag('MonthlyWorkerEdit') ||
          commonFn.btnAuthorityFlag('MonthlyWorkerChangeAmount') ||
          commonFn.btnAuthorityFlag('MonthlyWorkerVendorType') ||
          commonFn.btnAuthorityFlag('EditHistory')) &&
        (<Dropdown
          menu={{
            items: [
              commonFn.btnAuthorityFlag('MonthlyWorkerEdit') && {
                key: "MonthlyWorkerEdit",
                icon: <SearchOutlined style={{ color: "#00c0ef", fontSize: "16px" }}/>,
                label: <div>Edit Vendor M.Worker</div>,
              },
              commonFn.btnAuthorityFlag('MonthlyWorkerChangeAmount') && {
                key: "ChangeAmount",
                icon: <FormOutlined style={{ color: "#00c0ef", fontSize: "16px" }}/>,
                label: <div>Change Contract Amount</div>,
              },
              commonFn.btnAuthorityFlag('MonthlyWorkerVendorType') && {
                key: "MonthlyWorkerVendorType",
                icon: <HistoryOutlined style={{ color: "#00c0ef", fontSize: "16px" }} />,
                label: <div>Change Vendor Type</div>,
              },
              commonFn.btnAuthorityFlag('EditHistory') && {
                key: "EditHistory",
                icon: <HistoryOutlined style={{ color: "#00c0ef", fontSize: "16px" }} />,
                label: <div>Edit History</div>,
              },
            ].filter(Boolean),
            onClick: (e) => handleDetailClick(e.key, record),
          }}
          trigger={["click"]}
        >
          <MenuOutlined className="col-blue" />
        </Dropdown>) || null
      ),
    },
    {
      title: 'Vendor ID',
      dataIndex: "vendorId",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'vendorId')
    },
    {
      title: 'M.Worker Name',
      dataIndex: "name",
      titleType: 'Input',
      width:200,
      onChange: e => tableFilterFn(e, 'name')
    },
    {
      title: 'Current Monthly Rate',
      dataIndex: "monthlySalary",
      titleType: 'Input',
      isAmountFlag: true,
      width: 140,
      onChange: e => tableFilterFn(e, 'monthlySalary')
    },
    {
      title: 'Future Monthly Rate',
      dataIndex: "futureMonthlyRate",
      titleType: 'Input',
      isAmountFlag: true,
      width: 140,
      onChange: e => tableFilterFn(e, 'futureMonthlyRate')
    },
    {
      title: 'APP',
      dataIndex: "appActive",
      titleType: 'Input',
      width:80,
      onChange: e => tableFilterFn(e, 'appActive')
    },
    {
      title: 'Phone#',
      dataIndex: "phone",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'phone')
    },
    {
      title: 'Tax ID',
      dataIndex: "fedId",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'fedId')
    },
    {
      title: 'Group',
      dataIndex: "groupCode",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'groupCode'),
      render: (text, record) => (
        <Flex gap="4px 0" wrap>
          {record?.groupCodes?.map((item) => (
            <Tooltip title={item}>
              <Tag
                color="blue"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {item}
              </Tag>
            </Tooltip>
          ))}
        </Flex>
      ),
    },
    {
      title: 'Property',
      dataIndex: "propName",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'propName'),
      render: (text, record) => (
        <Flex gap="4px 0" wrap>
          {record?.propNames?.map((item) => (
            <Tooltip title={item}>
              <Tag
                color="blue"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {item}
              </Tag>
            </Tooltip>
          ))}
        </Flex>
      ),
    },
    {
      title: 'Supervisor',
      dataIndex: "supervisors",
      titleType: 'Select',
      selectOptions: supervisorList,
      onChange: e => tableFilterFn(e, 'supervisors', 'Select'),
      // render: (text, record) => (
      //   <Flex gap="4px 0" wrap>
      //     {record?.supervisorList?.map((item) => (
      //       <Tooltip title={item}>
      //         <Tag
      //           color="blue"
      //           style={{
      //             whiteSpace: "nowrap",
      //             overflow: "hidden",
      //             textOverflow: "ellipsis",
      //           }}
      //         >
      //           {item}
      //         </Tag>
      //       </Tooltip>
      //     ))}
      //   </Flex>
      // ),
    },
    {
      title: "Status",
      dataIndex: "status",
      titleType: "Select",
      selectOptions: [
        {value: 'A', label: 'Active'},
        {value: 'I', label: 'Inactive'},
      ],
      onChange: (e) => tableFilterFn(e, "status", 'Select'),
      render: (text) => {
        return text === "A" ? 'Active' : "Inactive"
      }
    },
    {
      title: "Last Date",
      dataIndex: "lastIssueCheck",
      titleType: "",
      width: 80,
      render: (text =>  text && moment(text).format("MM/DD/YYYY"))
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    const response = await http.get(api.vendorMonthlyShow, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };
  
  const getDictionaryFn = async() => {
    const response = await http.get(api.getDictionary, { params: {
        type:'util_payment',
        value: 'propType'
    }});
    setPropTypeList(response)
  }

  const supervisorListFn = async() => {
    const response = await http.get(api.getSupervisorNameDict);
    if (response.code === "1") {
      const list = (response?.data || [])?.map((item) => ({
        value: item.accountId,
        label: item.fullName,
      }));
      setSupervisorList(list);
    }
  }

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
  }

  const submitInitFn = () => {
    initColunmsFn()
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  }
    
  useEffect(() => {
    getDictionaryFn()
    supervisorListFn()
  }, [])

  useEffect(() => {
    if(propTypeList?.length || supervisorList?.length){
      setColumns(initColumns);
    }
  }, [propTypeList, supervisorList]);


  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])

    useImperativeHandle(ref, () => ({
    refresh: () => {
      // 刷新表格数据
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    }
  }));

  const handleDetailClick = async (key, record = {}) => {
    if(['New'].includes(key)){
      vendorMWorkerModalRef.current.openModal({type: 'New'})
    }else if(['MonthlyWorkerEdit'].includes(key)) {
      vendorMWorkerModalRef.current.openModal({
        type: 'Edit',
        oldState: record,
      })
    }else if(['ChangeAmount'].includes(key)) {
      changeAmountModalRef.current?.open(record)
    }else if(['MonthlyWorkerVendorType'].includes(key)) {
      vendorTypeModalRef.current?.open(record)
    }else if(['EditHistory'].includes(key)) {
      editHistoryModalRef.current?.openModal({
        modalName: 'Edit History',
        type: 'vendorMonthly',
        id: record?.id
      })
    }
  }

  const downLoadFn = async () => {
    const blob = await http.get(api.vendorVendorTypeExport, {
      params: { ...tableHead },
      responseType: "blob",
    });
    return {
      blob,
      name: `Monthly_Worker`,
    };
  };

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('MonthlyWorkerDownload') && 'download']}
        downLoadFn={() => downLoadFn()}
      >
        <div className="topLeft">
          {commonFn.btnAuthorityFlag('MonthlyWorkerNew') && <Space size="large">
            <Button className="btnNew" onClick={() => handleDetailClick('New')}>
              <PlusOutlined />
              New
            </Button>
          </Space> || null}
        </div>
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="340px"
      />
      <VendorMWorkerModal
        ref={vendorMWorkerModalRef}
        submitInitFn={submitInitFn}
      />
      <ChangeAmountModal
        ref={changeAmountModalRef}
        onSuccess={submitInitFn}
      />
      <VendorTypeModal
        ref={vendorTypeModalRef}
        onSuccess={submitInitFn}
      />
      <EditHistory
        ref={editHistoryModalRef}
      />
    </div>
  );
});
export default VendorMWorker;
